import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useServiceMappingDropdowns } from './use-service-mapping-dropdowns';
import { ShippingServiceDropdownSelectedValue } from '../../../../../components/shipping-service-selector/shipping-service-dropdown-selected-value';
import { ShippingServiceSearchableDropdown } from '../../../../../components/shipping-service-selector/shipping-service-searchable-dropdown';
import PackageDropdown from '../../../../../fulfillment-planner/package/dropdown';
import messages from '../messages';
// @ts-expect-error less import
import style from '../style.module.less';

const renderSelectedValue = ({ serviceId, sellerLabelProviderId, serviceCollectionGuid, isTemplate }) => {
  if (!serviceCollectionGuid && !serviceId) {
    return;
  }

  return (
    <ShippingServiceDropdownSelectedValue
      isTemplate={isTemplate}
      sellerLabelProviderId={sellerLabelProviderId}
      serviceCollectionGuid={serviceCollectionGuid}
      serviceId={serviceId}
    />
  );
};

/**
 * @typedef {import('../../../../../prop-types/package').PackagePropType} PackagePropType
 */

/**
 * @param {object} props
 * @param {(packageId: string) => void} props.setPackageId
 * @param {(serviceCollectionGuid: string) => void} props.setServiceCollectionGuid
 * @param {(shippingServiceId: string) => void} props.setShippingServiceId
 * @param {string} props.serviceCollectionGuid
 * @param {string} props.shippingServiceId
 * @param {string} [props.packageId]
 * @returns {JSX.Element}
 */
export const ShippingDropdown = ({
  packageId,
  serviceCollectionGuid,
  setPackageId,
  setShippingServiceId,
  setServiceCollectionGuid,
  shippingServiceId,
}) => {
  const { serviceGroups, packageGroups, selectedServiceOption } = useServiceMappingDropdowns({
    serviceId: shippingServiceId,
    serviceCollectionGuid,
  });

  const onServiceSelected = useCallback(
    ({ serviceCollectionGuid: newServiceCollectionGuid, serviceId }) => {
      setServiceCollectionGuid(newServiceCollectionGuid);
      setShippingServiceId(serviceId);
    },
    [setServiceCollectionGuid, setShippingServiceId],
  );

  return (
    <div className={style['service-mapping-box']}>
      <div className={style['service-mapping-title']}>
        <FormattedMessage {...messages.shippingSettings} />
      </div>

      <div className={style['service-mapping-dropdown-container']}>
        <label>
          <FormattedMessage {...messages.service} />
        </label>
        <ShippingServiceSearchableDropdown
          onSelected={onServiceSelected}
          renderSelectedValue={renderSelectedValue}
          selectedOption={selectedServiceOption}
          serviceGroups={serviceGroups}
        />
      </div>

      <div className={style['service-mapping-dropdown-container']}>
        <label>
          <FormattedMessage {...messages.package} />
        </label>
        <PackageDropdown
          onChange={setPackageId}
          packageGroups={packageGroups}
          selectedPackageIds={[packageId]}
          serviceCollectionGuid={serviceCollectionGuid}
        />
      </div>
    </div>
  );
};
